<!-- ===== REFONTE : formulaire de confirmation des invités (InviteFormComponent) ===== -->
<div class="iv-page">
  <div class="iv-carte">
    <div class="iv-entete">
      <img src="assets/img/logo_unchk.png" alt="UN-CHK" />
      <img
        src="assets/img/logo_force_n.png"
        alt="Force-N"
        class="iv-entete__forcen"
      />
      <img src="assets/img/logo_master_card.png" alt="Mastercard Foundation" />
    </div>

    <!-- Chargement -->
    <div class="iv-etat" *ngIf="etat === 'chargement'">
      <span class="iv-rond" aria-hidden="true"></span>
      <p>Chargement de votre invitation…</p>
    </div>

    <!-- Formulaire -->
    <div class="iv-corps" *ngIf="etat === 'formulaire' && invitation as inv">
      <div class="iv-kicker">Confirmation de participation</div>
      <h1>{{ inv.nomActivite }}</h1>

      <div class="iv-infos">
        <span *ngIf="inv.dateActivite"
          >📅
          <b>{{
            majuscule(inv.dateActivite | date: "EEEE d MMMM y" : "" : "fr")
          }}</b></span
        >
        <span *ngIf="inv.heure"
          >⏰ <b>{{ formatHeure(inv.heure) }}</b></span
        >
        <span *ngIf="inv.adresse"
          >📍 <b>{{ inv.adresse }}</b>
          <ng-container *ngIf="inv.lienLieu"
            >&nbsp;·&nbsp;<a
              [href]="inv.lienLieu"
              target="_blank"
              rel="noopener"
              >Voir sur la carte</a
            ></ng-container
          >
        </span>
      </div>

      <div class="iv-qui">
        <span class="iv-avatar" aria-hidden="true">{{ initiales }}</span>
        <span class="iv-qui__texte">
          <b>{{ inv.prenom }} {{ inv.nom }}</b>
          <span>{{ inv.email }}</span>
        </span>
        <span class="iv-verrou">🔒 Votre invitation</span>
      </div>

      <h2>Vos informations</h2>
      <form [formGroup]="formulaire" (ngSubmit)="confirmer()" novalidate>
        <div class="iv-grille">
          <div class="iv-champ">
            <label for="iv-structure">Structure <i>*</i></label>
            <input
              id="iv-structure"
              type="text"
              formControlName="structure"
              [class.iv-err]="invalide('structure')"
              autocomplete="organization"
            />
            <p class="iv-msg" *ngIf="invalide('structure')">Champ requis.</p>
          </div>
          <div class="iv-champ">
            <label for="iv-fonction">Fonction <i>*</i></label>
            <input
              id="iv-fonction"
              type="text"
              formControlName="fonction"
              placeholder="Ex. : gérante, vendeuse…"
              [class.iv-err]="invalide('fonction')"
              autocomplete="organization-title"
            />
            <p class="iv-msg" *ngIf="invalide('fonction')">Champ requis.</p>
          </div>
          <div class="iv-champ">
            <label for="iv-lieu">Région de provenance <i>*</i></label>
            <select
              id="iv-lieu"
              formControlName="lieuProvenance"
              [class.iv-err]="invalide('lieuProvenance')"
            >
              <option value="" disabled>Choisissez votre région</option>
              <option *ngFor="let region of regions" [value]="region.name">
                {{ region.name }}
              </option>
            </select>
            <p class="iv-msg" *ngIf="invalide('lieuProvenance')">
              Choisissez une région.
            </p>
          </div>
          <div class="iv-champ">
            <label for="iv-tel">Numéro de téléphone (Wave) <i>*</i></label>
            <div class="iv-tel">
              <span class="iv-indicatif">
                <svg viewBox="0 0 30 20" aria-hidden="true">
                  <rect width="10" height="20" fill="#00853f" />
                  <rect x="10" width="10" height="20" fill="#fdef42" />
                  <rect x="20" width="10" height="20" fill="#e31b23" />
                  <polygon
                    points="15,6.2 16.1,9.4 19.4,9.4 16.7,11.4 17.7,14.6 15,12.6 12.3,14.6 13.3,11.4 10.6,9.4 13.9,9.4"
                    fill="#00853f"
                  />
                </svg>
                +221
              </span>
              <input
                id="iv-tel"
                type="tel"
                inputmode="numeric"
                formControlName="numeroWave"
                placeholder="77 123 45 67"
                (input)="nettoyerNumero()"
                [class.iv-err]="invalide('numeroWave')"
                autocomplete="tel-national"
              />
            </div>
            <p class="iv-msg" *ngIf="invalide('numeroWave')">
              Le numéro doit comporter 9 chiffres.
            </p>
          </div>
        </div>

        <div class="iv-alerte" role="alert" *ngIf="messageErreur">
          {{ messageErreur }}
        </div>

        <div class="iv-actions">
          <button type="submit" class="iv-btn" [disabled]="envoi">
            <span
              class="iv-rond iv-rond--blanc"
              *ngIf="envoi"
              aria-hidden="true"
            ></span>
            {{ envoi ? "Envoi…" : "✓ Confirmer ma participation" }}
          </button>
          <p class="iv-note">
            Vos informations servent uniquement à l'organisation de l'atelier.
          </p>
        </div>
      </form>
    </div>

    <!-- Confirmé (juste après l'envoi) ou déjà confirmé (lien rouvert) -->
    <div
      class="iv-etat"
      *ngIf="(etat === 'confirme' || etat === 'deja') && invitation as inv"
    >
      <div
        class="iv-icone"
        [class.iv-icone--ok]="etat === 'confirme'"
        [class.iv-icone--info]="etat === 'deja'"
        aria-hidden="true"
      >
        {{ etat === "confirme" ? "✅" : "ℹ️" }}
      </div>
      <h1>
        {{ etat === "confirme" ? "Participation confirmée" : "Déjà confirmé" }}
      </h1>
      <p *ngIf="etat === 'confirme'">
        Merci <b>{{ inv.prenom }}</b> ! Nous vous attendons
        <ng-container *ngIf="inv.dateActivite">
          le
          <b>{{
            inv.dateActivite | date: "EEEE d MMMM y" : "" : "fr"
          }}</b></ng-container
        >
        <ng-container *ngIf="inv.heure">
          à <b>{{ formatHeure(inv.heure) }}</b></ng-container
        >
        <ng-container *ngIf="inv.adresse">, {{ inv.adresse }}</ng-container
        >.
      </p>
      <p *ngIf="etat === 'deja'">
        Vous avez déjà confirmé votre participation à
        <b>{{ inv.nomActivite }}</b
        >. Il n'y a rien d'autre à faire.
      </p>
      <div class="iv-nb" *ngIf="estAtelierForceN">
        <b>NB :</b> le jour de l'atelier, scannez le QR code affiché à l'entrée
        et utilisez <b>{{ inv.email }}</b> pour valider votre présence.
      </div>
    </div>

    <!-- Lien invalide, atelier fermé ou terminé -->
    <div class="iv-etat" *ngIf="etat === 'invalide'">
      <div class="iv-icone iv-icone--ko" aria-hidden="true">⚠️</div>
      <h1>Lien invalide ou expiré</h1>
      <p>
        Cette invitation est introuvable ou l'atelier est terminé. Si vous
        pensez qu'il s'agit d'une erreur, contactez l'équipe Force-N.
      </p>
    </div>

    <!-- Erreur réseau / serveur -->
    <div class="iv-etat" *ngIf="etat === 'erreur'">
      <div class="iv-icone iv-icone--ko" aria-hidden="true">⚠️</div>
      <h1>Un problème est survenu</h1>
      <p>Impossible de charger votre invitation pour le moment.</p>
      <button
        type="button"
        class="iv-btn iv-btn--secondaire"
        (click)="charger()"
      >
        Réessayer
      </button>
    </div>
  </div>
  <p class="iv-pied">
    <span class="iv-bleu">Force-N,&nbsp;</span
    ><span class="iv-orange">ton futur dans le numérique !</span>
  </p>
</div>
<!-- ===== FIN REFONTE ===== -->
